/**
 * Client-side auth/permission cache. The real auth token is an httpOnly cookie;
 * this just caches the user's profile + effective (module:action) set for UI
 * gating. Backed by an in-memory value + localStorage, with a subscribe() so
 * React can re-render on change (used by useCan/useAuth).
 */
const KEY = 'app:auth';
const listeners = new Set();

let current = load();

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch {
    return null;
  }
}

export function getAuth() {
  return current;
}

export function setAuth(user) {
  current = user;
  try {
    localStorage.setItem(KEY, JSON.stringify(user));
  } catch {}
  emit();
}

export function clearAuth() {
  current = null;
  try {
    localStorage.removeItem(KEY);
  } catch {}
  emit();
}

export function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function emit() {
  listeners.forEach((l) => l());
}

/** Capability check: tenant-admin bypasses; else look for "module:action". */
export function hasPermission(user, module, action) {
  if (!user) return false;
  if (user.isAdmin) return true;
  return Array.isArray(user.permissions) && user.permissions.includes(`${module}:${action}`);
}
